import './App.css';
import Tictactoe from './Component/Tictactoe/Tictactoe';

function App() {
  return (
    <div>
      <Tictactoe />
    </div>
  );
}

export default App